//NOTE - form First Page
export const couponRedeemMock = {
  ok: 1,
  status: 1,
  data: {
    rows: [
      {
        car_license: 'ดข0000',
        car_province: 'ชลบุรี',
      },
      {
        car_license: 'มข0001',
        car_province: 'นนทบุรี',
      },
      {
        car_license: '1กข0002',
        car_province: 'กรุงเทพมหานคร',
      },
      {
        car_license: '2กง0003',
        car_province: 'ปธุมธานี',
      },
    ],
  },
  msg: 'get data is success.',
};
